export const ServiceSearchCondition = [
  {
      name: '服务类别',
      key: '服务类别',
      open: false,
      box: [{
        title: '',
        key: '0',
        list: [{
          title: '',
          key: '0-0',
          items: [{
              index: 0,
              name: '全部',
              key: '全部全部',
              active: false
            },
            {
              index: 1,
              name: '咨询规划',
              key: '咨询规划',
              active: false
            },
            {
              index: 2,
              name: '专业设计',
              key: '专业设计',
              active: false
            },
            {
              index: 3,
              name: '工程建设',
              key: '工程建设',
              active: false
            },
            {
              index: 4,
              name: '人力外包',
              key: '人力外包',
              active: false
            },
            {
              index: 5,
              name: '监理审计',
              key: '监理审计',
              active: false
            },
            {
              index: 6,
              name: '创新场景',
              key: '创新场景',
              active: false
            },
            {
              index: 7,
              name: '金融服务',
              key: '金融服务',
              active: false
            },
          ]
        }, ]
      }, ]
    },
      {
        name: '专业领域',
        key: '专业领域',
        open: false,
        box: [{
            title: '',
            key: '专业领域-全部',
            list: [{
              title: '',
              key: 'list-0-专业领域-全部',
              items: [{
                name: '全部',
                key: 'item-0-专业领域-全部',
                active: false
              }, ]
            }, ]
          },
          {
            title: '',
            key: '智慧应用',
            list: [{
              title: '智慧应用',
              key: 'list-0-智慧应用',
              items: [{
                  name: '智慧政务应用',
                  key: '智慧政务应用',
                  active: false
                },
                {
                  name: '智慧城市应用',
                  key: '智慧城市应用',
                  active: false
                },
                {
                  name: '智慧民生应用',
                  key: '智慧民生应用',
                  active: false
                },
                {
                  name: '智慧产业应用',
                  key: '智慧产业应用',
                  active: false
                },
                {
                  name: '传统基础设施赋能',
                  key: '传统基础设施赋能',
                  active: false
                },
                {
                  name: '中小企业赋能',
                  key: '中小企业赋能',
                  active: false
                },
              ]
            }, ]
          },
          {
            title: '',
            key: '智能数据',
            list: [{
              title: '智能数据',
              key: 'list-0-智能数据',
              items: [{
                  name: '数据中心',
                  key: '数据中心',
                  active: false
                },
                {
                  name: '云边端',
                  key: '智能数据-云边端',
                  active: false
                },
                {
                  name: '大数据平台',
                  key: '大数据平台',
                  active: false
                },
                {
                  name: '人工智能',
                  key: '人工智能',
                  active: false
                },
                {
                  name: '区块链服务平台',
                  key: '区块链服务平台',
                  active: false
                },
                {
                  name: '数据交易',
                  key: '数据交易',
                  active: false
                },
              ]
            }, ]
          },
          {
            title: '',
            key: '生态系统',
            list: [{
              title: '生态系统',
              key: 'list-0-生态系统',
              items: [ // ['产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台']
                {
                  name: '产业园区生态',
                  key: '产业园区生态',
                  active: false
                },
                {
                  name: '共性支撑软件',
                  key: '共性支撑软件',
                  active: false
                },
                {
                  name: '科学仪器',
                  key: '科学仪器',
                  active: false
                },
                {
                  name: '中试服务生态',
                  key: '中试服务生态',
                  active: false
                },
                {
                  name: '共享开源平台',
                  key: '共享开源平台',
                  active: false
                }
              ]
            }, ]
          },
          {
            title: '',
            key: '可信安全',
            list: [{
              title: '可信安全',
              key: 'list-0-可信安全',
              items: [ // ['基础安全能力', '行业应用安全', '新型安全服务平台'],
                {
                  name: '基础安全能力',
                  key: '基础安全能力',
                  active: false
                },
                {
                  name: '行业应用安全',
                  key: '行业应用安全',
                  active: false
                },
                {
                  name: '新型安全服务平台',
                  key: '新型安全服务平台',
                  active: false
                }
              ]
            }, ]
          },
          {
            title: '',
            key: '新型网络',
            list: [{
              title: '新型网络',
              key: 'list-0-新型网络',
              items: [ // ['5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网'],
                {
                  name: '5G网络',
                  key: '5G网络',
                  active: false
                },
                {
                  name: '千兆固网',
                  key: '千兆固网',
                  active: false
                },
                {
                  name: '卫星互联网',
                  key: '卫星互联网',
                  active: false
                },
                {
                  name: '车联网',
                  key: '车联网',
                  active: false
                },
                {
                  name: '工业互联网',
                  key: '工业互联网',
                  active: false
                },
                {
                  name: '政务专网',
                  key: '政务专网',
                  active: false
                },
              ]
            }, ]
          },
          {
            title: '',
            key: '智慧专区',
            list: [{
              title: '智慧专区',
              key: 'list-0-智慧专区',
              items: [ // ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
                {
                  name: '智慧住建',
                  key: '智慧住建',
                  active: false
                },
                {
                  name: '智慧园区',
                  key: '智慧园区',
                  active: false
                },
                {
                  name: '智慧社区',
                  key: '智慧社区',
                  active: false
                },
                {
                  name: '智慧出行',
                  key: '智慧出行',
                  active: false
                },
                {
                  name: '智慧健康',
                  key: '智慧健康',
                  active: false
                },
                {
                  name: '智慧教育',
                  key: '智慧教育',
                  active: false
                },
                {
                  name: '智慧政务',
                  key: '智慧政务',
                  active: false
                },
              ]
            }, ]
          },
          {
            title: '',
            key: '数字上云',
            list: [{
              title: '数字上云',
              key: 'list-0-数字上云',
              items: [ // ['云计算', '域名', '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'],
                {
                  name: '云计算',
                  key: '云计算',
                  active: false
                },
                {
                  name: '域名',
                  key: '域名',
                  active: false
                },
                {
                  name: '内容安全',
                  key: '内容安全',
                  active: false
                },
                {
                  name: '网络',
                  key: '网络',
                  active: false
                },
                {
                  name: '存储与CDN',
                  key: '存储与CDN',
                  active: false
                },
                {
                  name: 'AI开放服务',
                  key: 'AI开放服务',
                  active: false
                },
                {
                  name: '数据库',
                  key: '数据库',
                  active: false
                },
                {
                  name: '其它产品服务提供商',
                  key: '其它产品服务提供商',
                  active: false
                },
              ]
            }, ]
          },
          {
            title: '',
            key: '金融服务',
            list: [{
              title: '金融服务',
              key: 'list-0-金融服务',
              items: [ // ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
                {
                  name: '银行服务',
                  key: '银行服务',
                  active: false
                },
                {
                  name: '风险投资',
                  key: '风险投资',
                  active: false
                },
                {
                  name: '投资基金',
                  key: '投资基金',
                  active: false
                },
                {
                  name: '融资担保',
                  key: '融资担保',
                  active: false
                },
                {
                  name: '债券股票',
                  key: '债券股票',
                  active: false
                },
                {
                  name: '民间借贷',
                  key: '民间借贷',
                  active: false
                },
              ]
            }, ]
          },
        ]
      },
    ]